var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{style:(_vm.footerStyles)},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"disclaimer"},[_c('p',{staticClass:"first-section"}),_vm._v(" "),_c('p',{staticClass:"first-section"})])
}]

export { render, staticRenderFns }